module.exports = __webpack_public_path__ + "static/flourish-lines-right-a21547276c808d65e69474aa11902d82.png";